import withLang from './withLang';
import withAuth from './withAuth';

export { withAuth, withLang };
